// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import VueWait from 'vue-wait';
// import Navigation from 'vue-navigation'
// import VueAwesomeSwiper from 'vue-awesome-swiper';
import App from './App';
import router from './router';
import $api from './utils/api';
import { appCmdApply } from './utils/utils'
import './utils/language'
const NEED_APP_HEADER_LIST = [];

// eslint-disable-next-line import/first
// import 'swiper/css/swiper.css';
// import Vant from 'vant';
import './common/stylus/font.css';

// import './common/stylus/animate.css';
// import animate from 'animate.css'

// Vue.use(animate);
// import 'vant/lib/index.css'

// Vue.use(Navigation, {router, keyName: 'VSK'})

//if (true) {
if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line global-require
    const Vconsole = require('vconsole');
    const vConsole = new Vconsole();
    Vue.use(vConsole);
}
Vue.prototype.$appCmdApply = appCmdApply;

Vue.prototype.$api = $api;
// Vue.use(Vant);
Vue.use(VueWait); // Loading集中管理控件
// Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;
console.log(process.env.NODE_ENV);
const wait = new VueWait({ registerComponents: false });
window.$wait = wait;
/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
    let fromName = from.path.replace('/', '');
    let toName = to.path.replace('/', '');

    if (!fromName) {
        return next()
    }
    if (fromName === toName) {
        next()
    } else {
        NEED_APP_HEADER_LIST.indexOf(toName) != -1 ?
            appCmdApply('openNavigation') :
            appCmdApply('closeNavigation')
        next()
    }

});

new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>',
    wait,
});


// WEBPACK FOOTER //
// ./src/main.js